import React from 'react';
import { TeamMemberInfo } from './utils';

interface JobTitleProps {
  memberInfo: TeamMemberInfo;
  setMemberInfo: (info: TeamMemberInfo) => void;
}

const JobTitle: React.FC<JobTitleProps> = ({ memberInfo, setMemberInfo }) => {
  return (
    <div>
      <div className="flex gap-5 items-end">
        <div className="govuk-form-group">
          <h2 className="govuk-label-wrapper">
            <label
              className="govuk-label govuk-label--m"
              htmlFor="job-title-input"
            >
              What is the person&apos;s job title
            </label>
          </h2>
          <input
            className="govuk-input govuk-input--width-20"
            id="job-title-input"
            name="jobTitle"
            type="text"
            autoComplete="jobTitle"
            placeholder="Enter job title"
            value={memberInfo.jobTitle}
            onChange={e =>
              setMemberInfo({ ...memberInfo, jobTitle: e.target.value })
            }
          />
        </div>
      </div>
    </div>
  );
};

export default JobTitle;
